import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import Link from "@mui/material/Link";

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText:
    "Add 2 games for 15% off your tickets, add 4 games for 20% off, add 6 games for 25% off, add 8 games for Fireworks on the Field or add 10+ games for an exclusive batting practice experience!",
  progressBarAditionalText: "to continue.",
};

export const WichitaWindSurgeLink = ({
  fontWeight,
}: {
  fontWeight?: number;
}) => (
  <Link
    href={"https://mlb.tickets.com/?agency=MILB_MPV&orgid=56869#/auth/login"}
    target={"_blank"}
    sx={{
      fontWeight: fontWeight || 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyTickets
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your Wichita Wind Surge Flex Plan account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <WichitaWindSurgeLink /> account
        within 24 hours of purchase. Reach out to Live Fan Support or Wichita
        Wind Surge Box Office at{" "}
        <Link
          href="tel:316-221-8000"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (316) 221-8000
        </Link>{" "}
        for any questions.
      </>
    ),
  },
];
export const faqs = [
  {
    title: "How does the Wichita Wind Surge Flex Pack work? ",
    description:
      "The Wichita Wind Surge Flex Pack allows fans to select any seat to select games hosted by the Wichita Wind Surge. Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Wichita Wind Surge{" "}
        <WichitaWindSurgeLink /> Account.
      </>
    ),
  },
  {
    title:
      "How do I find out more information about Fireworks on the Field or batting practice?",
    description: (
      <>
        If eligible, the box office will be in touch with you after you complete
        your purchase to arrange the details for your fireworks or batting
        practice experience. They can be reached at{" "}
        <Link
          href="tel:316-221-8000"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (316) 221-8000
        </Link>
        .
      </>
    ),
  },
];
